import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgCopyToClipboard = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.74 0v2.18H4.1v15.27H2V2.18A2.15 2.15 0 0 1 4.1 0Zm3.16 6.55H8.32v15.27H19.9Zm0-2.19A2.15 2.15 0 0 1 22 6.55v15.27A2.15 2.15 0 0 1 19.9 24H8.32a2.15 2.15 0 0 1-2.11-2.18V6.55a2.15 2.15 0 0 1 2.11-2.19Z"
    }));
export default SvgCopyToClipboard;
